import { configureStore, combineReducers } from "@reduxjs/toolkit"
import globalReducer from "./reducer/GlobalReducer";
import assetsReducer from "./reducer/assets/AssetsReducer"
import dashboardReducer from "./reducer/dashboard/DashboardReducer"
import plansReducer from "./reducer/plans/PlansReducer"
import paymentsReducer from "./reducer/payments/PaymentsReducer"
import customerReducer from "./reducer/customer/CustomerReducer"

const appReducer = combineReducers({
    ...globalReducer,
    ...assetsReducer,
    ...dashboardReducer,
    ...plansReducer,
    ...paymentsReducer,
    ...customerReducer,
});

// Wipe all cached customer data on logout and before any new login,
// so the next user never sees the previous user's data.
const RESET_ACTIONS = ['signOut/fulfilled', 'SignIn/pending', 'PhoneLoginSelectUser/pending']
const rootReducer = (state, action) => appReducer(RESET_ACTIONS.includes(action.type) ? undefined : state, action)

const alexa_farm_store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default alexa_farm_store;